<template>
    <!-- 价格卡片 (4列) -->
    <div class="w-full flex justify-center gap-2">
        <!-- Basic Plan -->
        <div class="w-[240px] rounded-[20px] bg-white p-4 border border-[#DDEBF8]">
            <div class="flex flex-col self-stretch mb-6">
                <div class="flex w-full items-start justify-between gap-1 flex-wrap">
                    <h3 class="flex-1 text-xl font-semibold leading-[1.4] text-[#020A1A]">
                        {{ t('plans.basic.name') }}
                    </h3>
                </div>
            </div>

            <div class="flex gap-4">
                <div class="relative flex flex-col gap-4 w-[222px]">
                    <div class="flex flex-col gap-1 self-stretch">
                        <div class="text-3xl font-semibold leading-[1.33] text-[#020A1A] flex flex-row flex-wrap items-end gap-1">
                            {{ t('plans.basic.pricing') }}
                        </div>
                    </div>

                    <p class="self-stretch text-sm leading-[1.43] text-[#495973] mt-6">
                        {{ t('plans.basic.description') }}
                    </p>

                    <button
                        disabled
                        class="flex items-center justify-center gap-2.5 self-stretch rounded-[20px] px-7 py-2 text-sm font-semibold leading-[1.5] transition-all bg-[#F4F5F7] text-[#020A1A] cursor-not-allowed"
                    >
                        {{ t('plans.basic.cta') }}
                    </button>

                    <div class="flex flex-col gap-2 self-stretch">
                        <div class="text-sm leading-[1.71] text-[#020A1A] mb-1">
                            {{ t('plans.basic.featuresHeader') }}
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.basic.features.0') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.basic.features.1') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.basic.features.2') }}
                            </span>
                        </div>
                    </div>
                    <div class="flex flex-col gap-2 self-stretch">
                        <div class="text-sm leading-[1.71] text-[#020A1A] mb-1">
                            {{ t('plans.basic.featuresHeader2') }}
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.basic.features.3') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.basic.features.4') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.basic.features.5') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.basic.features.6') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.basic.features.7') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.basic.features.8') }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Pro Plan -->
        <div v-if="!checkJpEnv()" class="relative w-[450px] rounded-[20px] bg-white p-4 border border-[#0A3DFF]">
            <div class="most-popular">{{ t('mostPopular') }}</div>
            <div class="flex flex-col self-stretch mb-6">
                <div class="flex w-full items-start justify-between gap-1 flex-wrap">
                    <h3 class="flex-1 text-xl font-semibold leading-[1.4] text-[#020A1A]">
                        {{ t('plans.pro.name') }}
                    </h3>

                    <!-- <div class="flex items-center gap-1 bg-[#F4F5F7] rounded-full p-0.5">
                        <button
                            :class="[
                                'px-3 py-1 rounded-full text-xs font-medium transition-all',
                                billingCycle === 'monthly'
                                    ? 'bg-white text-[#020A1A] shadow-sm'
                                    : 'bg-transparent text-[#8993A4]'
                            ]"
                            @click="billingCycle = 'monthly'"
                        >
                            {{ t('billingCycle.monthly') }}
                        </button>
                        <button
                            :class="[
                                'px-3 py-1 rounded-full text-xs font-medium transition-all flex items-center gap-1',
                                billingCycle === 'yearly'
                                    ? 'bg-white text-[#020A1A] shadow-sm'
                                    : 'bg-transparent text-[#8993A4]'
                            ]"
                            @click="billingCycle = 'yearly'"
                        >
                            {{ t('billingCycle.yearly') }}
                            <span class="text-[10px] text-[#008236] font-semibold">{{ t('billingCycle.saveAmount', { amount: 0 }) }}</span>
                        </button>
                    </div> -->
                </div>
            </div>

            <div class="flex gap-4">
                <!-- Patent Search -->
                <div class="relative flex flex-col gap-4 w-[222px]">
                    <div class="flex flex-col gap-1 self-stretch">
                        <div class="text-eureka-500 text-xs mb-1">{{ t('plans.proSearch.name') }}</div>
                        <p class="self-stretch text-sm leading-[1.43] text-[#495973]">
                            {{ t('plans.proSearch.desc') }}
                        </p>
                        <div class="text-3xl font-semibold leading-[1.33] text-[#020A1A] flex flex-row flex-wrap items-end gap-1">
                            <div>{{ billingCycle === 'monthly' ? '$400' : '$4320' }}</div>
                            <div class="text-sm font-medium text-[#8993A4] pb-2">/ {{ billingCycle === 'monthly' ? t('month') : t('year')}}</div>
                        </div>
                        <div class="inline-flex items-center gap-1 bg-[#F4F5F7] rounded-full p-0.5 self-start">
                            <button
                                :class="[
                                    'px-3 py-1 rounded-full text-xs font-medium transition-all',
                                    billingCycle === 'monthly'
                                        ? 'bg-white text-[#020A1A] shadow-sm'
                                        : 'bg-transparent text-[#8993A4]'
                                ]"
                                @click="billingCycle = 'monthly'"
                            >
                                {{ t('billingCycle.monthly') }}
                            </button>
                            <button
                                :class="[
                                    'px-3 py-1 rounded-full text-xs font-medium transition-all flex items-center gap-1',
                                    billingCycle === 'yearly'
                                        ? 'bg-white text-[#020A1A] shadow-sm'
                                        : 'bg-transparent text-[#8993A4]'
                                ]"
                                @click="billingCycle = 'yearly'"
                            >
                                {{ t('billingCycle.yearly') }}
                                <span class="text-[10px] text-[#008236] font-semibold">{{ t('billingCycle.saveAmount', { amount: 480 }) }}</span>
                            </button>
                        </div>
                    </div>

                    <!-- <p class="self-stretch text-sm leading-[1.43] text-[#495973]">
                        {{ billingCycle === 'monthly' ? t('plans.proSearch.pricing.monthly') : t('plans.proSearch.pricing.yearly') }}
                    </p> -->

                    <button
                        class="flex items-center justify-center gap-2.5 self-stretch rounded-[20px] px-7 py-2 text-sm font-semibold leading-[1.5] transition-all bg-[#0A3DFF] text-white hover:bg-[#0456D1]"
                        @click="handlePlanAction('checking')"
                    >
                        {{ t('plans.proSearch.buttonText') }}
                    </button>

                    <div class="flex flex-col gap-2 self-stretch">
                        <div class="text-sm leading-[1.71] text-[#020A1A] mb-1">
                            {{ t('plans.proSearch.featuresHeader') }}
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.proSearch.features.0') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.proSearch.features.1') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.proSearch.features.2') }}
                            </span>
                        </div>
                    </div>
                </div>

                <!-- Patent Drafting -->
                <div class="relative flex flex-col gap-4 w-[222px]">
                    <div class="flex flex-col gap-1 self-stretch">
                        <div class="text-eureka-500 text-xs mb-1">{{ t('plans.proDrafting.name') }}</div>
                        <p class="self-stretch text-sm leading-[1.43] text-[#495973]">
                            {{ t('plans.proDrafting.desc') }}
                        </p>
                        <div class="text-3xl font-semibold leading-[1.33] text-[#020A1A] flex flex-row flex-wrap items-end gap-1">
                            <div>{{ draftingBillingCycle === 'monthly' ? '$200' : '$2160' }}</div>
                            <div class="text-sm font-medium text-[#8993A4] pb-2">/ {{ draftingBillingCycle === 'monthly' ? t('month') : t('year')}}</div>
                        </div>
                        <div class="inline-flex items-center gap-1 bg-[#F4F5F7] rounded-full p-0.5 self-start">
                            <button
                                :class="[
                                    'px-3 py-1 rounded-full text-xs font-medium transition-all',
                                    draftingBillingCycle === 'monthly'
                                        ? 'bg-white text-[#020A1A] shadow-sm'
                                        : 'bg-transparent text-[#8993A4]'
                                ]"
                                @click="draftingBillingCycle = 'monthly'"
                            >
                                {{ t('billingCycle.monthly') }}
                            </button>
                            <button
                                :class="[
                                    'px-3 py-1 rounded-full text-xs font-medium transition-all flex items-center gap-1',
                                    draftingBillingCycle === 'yearly'
                                        ? 'bg-white text-[#020A1A] shadow-sm'
                                        : 'bg-transparent text-[#8993A4]'
                                ]"
                                @click="draftingBillingCycle = 'yearly'"
                            >
                                {{ t('billingCycle.yearly') }}
                                <span class="text-[10px] text-[#008236] font-semibold">{{ t('billingCycle.saveAmount', { amount: 240 }) }}</span>
                            </button>
                        </div>
                    </div>

                    <!-- <p class="self-stretch text-sm leading-[1.43] text-[#495973]">
                        {{ billingCycle === 'monthly' ? t('plans.proDrafting.pricing.monthly') : t('plans.proDrafting.pricing.yearly') }}
                    </p> -->

                    <button
                        class="flex items-center justify-center gap-2.5 self-stretch rounded-[20px] px-7 py-2 text-sm font-semibold leading-[1.5] transition-all bg-[#0A3DFF] text-white hover:bg-[#0456D1]"
                        @click="handlePlanAction('drafting')"
                    >
                        {{ t('plans.proDrafting.buttonText') }}
                    </button>

                    <div class="flex flex-col gap-2 self-stretch">
                        <div class="text-sm leading-[1.71] text-[#020A1A] mb-1">
                            {{ t('plans.proDrafting.featuresHeader') }}
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.proDrafting.features.0') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.proDrafting.features.1') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.proDrafting.features.2') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.proDrafting.features.3') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.proDrafting.features.4') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.proDrafting.features.5') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.proDrafting.features.6') }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Enterprise Plan -->
        <div class="w-[240px] rounded-[20px] bg-white p-4 border border-[#DDEBF8]">
            <div class="flex flex-col self-stretch mb-6">
                <div class="flex w-full items-start justify-between gap-1 flex-wrap">
                    <h3 class="flex-1 text-xl font-semibold leading-[1.4] text-[#020A1A]">
                        {{ t('plans.enterprise.name') }}
                    </h3>
                </div>
            </div>

            <div class="flex gap-4">
                <div class="relative flex flex-col gap-4 w-[222px]">
                    <div class="flex flex-col gap-1 self-stretch">
                        <div class="text-3xl font-semibold leading-[1.33] text-[#020A1A] flex flex-row flex-wrap items-end gap-1">
                            {{ t('plans.enterprise.title') }}
                        </div>
                    </div>

                    <p class="self-stretch text-sm leading-[1.43] text-[#495973] mt-6">
                        {{ t('plans.enterprise.description') }}
                    </p>

                    <button
                        class="flex items-center justify-center gap-2.5 self-stretch rounded-[20px] px-7 py-2 text-sm font-semibold leading-[1.5] transition-all bg-[#020A1A] text-white hover:bg-[#364153]"
                        @click="handleContactSales"
                    >
                        {{ t('plans.enterprise.buttonText') }}
                    </button>

                    <div class="flex flex-col gap-2 self-stretch">
                        <div class="text-sm leading-[1.71] text-[#020A1A] mb-1">
                            {{ t('plans.enterprise.featuresHeader') }}
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.enterprise.features.0') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.enterprise.features.1') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.enterprise.features.2') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.enterprise.features.3') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.enterprise.features.4') }}
                            </span>
                        </div>
                    </div>

                    <div class="flex flex-col gap-2 self-stretch">
                        <div class="text-sm leading-[1.71] text-[#020A1A] mb-1">
                            {{ t('plans.enterprise.featuresHeader2') }}
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.enterprise.features.5') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.enterprise.features.6') }}
                            </span>
                        </div>
                    </div>

                    <div class="flex flex-col gap-2 self-stretch">
                        <div class="text-sm leading-[1.71] text-[#020A1A] mb-1">
                            {{ t('plans.enterprise.featuresHeader3') }}
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.enterprise.features.7') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.enterprise.features.8') }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- API Plan -->
        <div class="w-[240px] rounded-[20px] bg-white p-4 border border-[#DDEBF8]">
            <div class="flex flex-col self-stretch mb-6">
                <div class="flex w-full items-start justify-between gap-1 flex-wrap">
                    <h3 class="flex-1 text-xl font-semibold leading-[1.4] text-[#020A1A]">
                        {{ t('plans.api.name') }}
                    </h3>
                </div>
            </div>

            <div class="flex gap-4">
                <div class="relative flex flex-col gap-4 w-[222px]">
                    <div class="flex flex-col gap-1 self-stretch">
                        <div class="text-3xl font-semibold leading-[1.33] text-[#020A1A] flex flex-row flex-wrap items-end gap-1">
                            {{ t('plans.api.title') }}
                        </div>
                    </div>

                    <p class="self-stretch text-sm leading-[1.43] text-[#495973] mt-6">
                        {{ t('plans.api.description') }}
                    </p>

                    <button
                        class="flex items-center justify-center gap-2.5 self-stretch rounded-[20px] px-7 py-2 text-sm font-semibold leading-[1.5] transition-all bg-[#020A1A] text-white hover:bg-[#364153]"
                        @click="handleApiClick"
                    >
                        {{ t('plans.api.buttonText') }}
                    </button>

                    <div class="flex flex-col gap-2 self-stretch">
                        <!-- <div class="text-sm leading-[1.71] text-[#020A1A] mb-1">
                            {{ t('plans.api.featuresHeader') }}
                        </div> -->
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.api.features.0') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.api.features.1') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.api.features.2') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.api.features.3') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.api.features.4') }}
                            </span>
                        </div>
                        <div class="flex gap-2 self-stretch items-start">
                            <PtIcon icon="SolidTickCircle" class="text-lg fill-[#0A3DFF] flex-shrink-0 mt-0.5" />
                            <span class="text-sm leading-[1.43] text-[#495973]">
                                {{ t('plans.api.features.5') }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { PtIcon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/TickCircle.svg';
import { openClueReport } from '@eureka/shared/clue-report';
import { EurekaPackageType } from '@eureka/services/src/apis/common.api.types';
import { checkJpEnv } from '../utils/check-jp-env';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { BiTrackService } from '@eureka/domains/src/bi-track/services/bi-track-service';
import { EurekaTrackEventType } from '@eureka/domains/src/bi-track/types';
// import { isInternationalSite } from '@eureka/utils/environment';
// import { isUserLogin } from '@eureka/utils/account';
// import { openLoginDialog } from '@eureka/shared/login-iframe';
// import { Site, SLD } from '@patsnap-utils/biz';
import * as messages from '../locales';
// import { PLAN_LIMITS } from '../config/plan-limits';

const { t } = useI18n({
    messages,
});

const billingCycle = ref<'monthly' | 'yearly'>('monthly');

const draftingBillingCycle = ref<'monthly' | 'yearly'>('monthly');

const biTrackService = injectService<BiTrackService>(BiTrackService);

// const searchingBillingCycle = ref<'monthly' | 'yearly'>('monthly');

const handlePlanAction = (plan: string) => {
    // 埋点：升级页面按钮点击
    biTrackService.biTrack(EurekaTrackEventType.SS_EUREKA_UPGRADE_PAGE, {
        sourceType: 'click_subscribe_pro',
        eventDetailStr: {
            product_line: 'eureka_ip',
        },
    });

    if (plan === 'drafting') {
        const priceId = draftingBillingCycle.value === 'monthly' ? import.meta.env.VITE_STRIPE_PRICE_DRAFTING_MONTHLY : import.meta.env.VITE_STRIPE_PRICE_DRAFTING_YEARLY
        const url = `/ip/drafting/#/upgrade?auto_pay=1&priceId=${priceId}`
        window.location.href = url
    }
    if (plan === 'checking') {
        const priceId = billingCycle.value === 'monthly' ? import.meta.env.VITE_STRIPE_PRICE_SEARCHING_MONTHLY : import.meta.env.VITE_STRIPE_PRICE_SEARCHING_YEARLY
        const url = `/ip/checking/#/package?auto_pay=1&priceId=${priceId}`
        window.location.href = url
    }
};

const handleContactSales = () => {
    // 国外游客版（未登录）打开登录框
    // if (isInternationalSite() && !isLogin.value) {
    //     openLoginDialog();
    //     return;
    // }

    openClueReport({
        pkgType: EurekaPackageType.AIR_COMMERCIAL,
        version: 'AIR',
    });
};

const handleApiClick = () => {
    window.open('https://open.patsnap.com?utm_source=eureka_IP', '_blank');
};

// onMounted(async() => {
//     isLogin.value = await isUserLogin();
// });
</script>

<style lang="scss">
.most-popular {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #0A3DFF;
    border-radius: 20px;
    padding: 0 8px;
    color: #fff;
    font-size: 12px;
}
</style>
